import { PERMISSION } from "src/types";

/**
 * Permission helpers utils providing easier reasoning logic
 *
 * For button / action components, the PERMISSIONS are straightforward:
 * - HIDDEN: shows no visible button
 * - DISABLED: show the button, but in a disabled state
 * - ENABLED: show the button in enabled state
 *
 * For input components, the PERMISSIONS are:
 * - HIDDEN: show component in readonly mode
 * - DISABLED: show component in readonly mode
 * - ENABLED: show component in edit mode
 *
 * When using the permissions for other visualisation,
 *  e.g. a form in readonly mode, this is less straightforward.
 *  The permission "updateRegularGrid" set on HIDDEN hides the action button,
 *  but the form fields can still be visualized in a READ_ONLY mode.
 *
 *  In other words it depends
 */

export function isVisible(permission: PERMISSION) {
  return permission !== PERMISSION.HIDDEN;
}

export function isHidden(permission: PERMISSION) {
  return permission === PERMISSION.HIDDEN;
}

export function isEnabled(permission: PERMISSION) {
  return permission === PERMISSION.ENABLED;
}

export function isDisabled(permission: PERMISSION) {
  return permission !== PERMISSION.ENABLED;
}

export function isReadOnly(permission: PERMISSION) {
  return isDisabled(permission) || isHidden(permission);
}
